// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2.34.2." + __webpack_require__.h() + ".min.js";
};